module.exports = __webpack_public_path__ + "img/mon_rotated.95bf9797.png";